import { render, staticRenderFns } from "./viewPromotedApps.vue?vue&type=template&id=709bf9c6&scoped=true"
import script from "./viewPromotedApps.vue?vue&type=script&lang=js"
export * from "./viewPromotedApps.vue?vue&type=script&lang=js"
import style0 from "./viewPromotedApps.vue?vue&type=style&index=0&id=709bf9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709bf9c6",
  null
  
)

export default component.exports